import { render, staticRenderFns } from "./caiWuXinXi.vue?vue&type=template&id=9546b60e&scoped=true&"
import script from "./caiWuXinXi.vue?vue&type=script&lang=js&"
export * from "./caiWuXinXi.vue?vue&type=script&lang=js&"
import style0 from "./caiWuXinXi.vue?vue&type=style&index=0&id=9546b60e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9546b60e",
  null
  
)

export default component.exports